import {
    FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM,
    MESSAGE_DOES_NOT_BELONG_TO_FORUM,
    PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG,
} from 'mk/autogenerated/translations/Complaint.constants.0695a04b796c65e3ff57e5969cb78dc7'

export const TITLES = {
    'forum-thread': MESSAGE_DOES_NOT_BELONG_TO_FORUM,
    'photoblog-comment': PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG,
    'forum-message': FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM,
};
